/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Fragment, useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router-dom'
import {useSearchParams} from 'react-router-dom'
import useServices from '../../../utils/hooks/useServices'
import UserServices from '../../../services/user'
import MasterServices from '../../../services/master'
import CompanyServices from '../../../services/company'
import tabsMenuCompany from './tabsMenuCompany'
import tabsMenuAlumni from './tabsMenuAlumni'
import {menusAdditionalAlumni} from '../../../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuMain'

type Props = {
  menus?: any
}

const ProfileHeader: React.FC<Props> = ({menus}) => {
  const fileInput = React.useRef<any>({})
  const role = localStorage.getItem('role')
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const [file, setFile] = useState<any>(null)

  const allowedUrl = [
    // allowed company moodule
    '/crafted/pages/profile/company-overview',
    '/crafted/pages/profile/company-job',
    // allowed alumni module
    '/crafted/pages/profile/basic-overview',
    '/crafted/pages/profile/personal-information',
    '/crafted/pages/profile/education',
    '/crafted/pages/profile/experience',
    '/crafted/pages/profile/skill',
    '/crafted/pages/profile/language',
    '/crafted/pages/profile/other',
  ]
  const currentUri = window.location.pathname

  const [dataAlumni, setDataAlumni] = useState<any>({})

  const [data, loading, makeItEmpty, triggerRefresh, isError, setLoading] = useServices(
    role === 'company'
      ? MasterServices.getCompanyProfile
      : currentUri?.includes(allowedUrl[0]) || currentUri?.includes(allowedUrl[1])
      ? CompanyServices.showCompany
      : UserServices.getProfile,
    searchParams.get('company')
  )
  const [alumni] = useServices(MasterServices.showUser, searchParams.get('alumni'))

  const [company, setCompany] = useState<any>({})
  const [finalMenu, setFinalMenu] = useState<any>([])
  useEffect(() => {
    if (searchParams.get('alumni')) {
      setDataAlumni(alumni?.data)
    }
  }, [alumni])

  useEffect(() => {
    if (role === 'company') {
      setFinalMenu(tabsMenuCompany)
    } else if (currentUri?.includes(allowedUrl[0]) || currentUri?.includes(allowedUrl[1])) {
      setFinalMenu(menusAdditionalAlumni)
    } else if (role === 'alumni') {
      setFinalMenu(tabsMenuAlumni)
    } else {
      setFinalMenu(tabsMenuAlumni)
    }
  }, [])

  useEffect(() => {
    if (data.data) setCompany(data?.data)
  }, [data])

  const handleDownloadResume = async () => {
    let id
    if (searchParams.get('alumni')) {
      id = searchParams.get('alumni')
    } else {
      id = data?.id_hash
    }

    try {
      const response: any = await UserServices.downloadResume(id)
      const {file, name} = response.data
      var a = document.createElement('a')
      a.href = file
      a.download = name
      document.body.appendChild(a)
      a.click()
      a.remove()
    } catch (error) {
    }
  }

  const onBtnClick = () => {
    document.getElementById('input-file-avatar')?.click()
  }

  const onChange = async (e: any) => {
    setFile(e.target.files[0])
    if (window.confirm('Upload foto sekarang ?')) {
      let success
      if (role == 'Alumni') {
        success = await UserServices.uploadPhotoProfile({file: e.target.files[0]})
      } else {
        success = await CompanyServices.uploadPhotoProfile({image: e.target.files[0]})
      }
      if (success) {
        triggerRefresh()
      }
    }
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-body pt-9 pb-0'>
        <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
          <div className='me-7 mb-4'>
            <div className='image-input image-input-outline image-input-changed'>
              <form action='/users/save-image' id='form-upload-image'>
                <img
                  src={
                    dataAlumni?.detail?.photo_url_full ||
                    data?.detail?.photo_url_full ||
                    data?.data?.logo_url_full ||
                    data?.detail?.user_details_photo ||
                    toAbsoluteUrl('/media/avatars/300-1.jpg')
                  }
                  alt='Metornic'
                  onClick={onBtnClick}
                  style={{display: 'block', height: '130px', width: '130px'}}
                />
                {searchParams.get('company') ? null : (
                  <label
                    className='btn btn-icon btn-circle btn-primary w-25px h-25px'
                    data-kt-image-input-action='change'
                    data-bs-toggle='tooltip'
                    aria-label='Ubah foto profil'
                    data-bs-original-title='Ubah foto profil'
                    data-kt-initialized='1'
                  >
                    <i className='bi bi-pencil' id='icon-upload'></i>
                    <input
                      type='file'
                      id='input-file-avatar'
                      accept='image/jpeg, image/png'
                      style={{display: 'none'}}
                      name='GeneralImages'
                      onChange={onChange}
                    />
                  </label>
                )}
              </form>
            </div>
          </div>

          <div className='flex-grow-1'>
            <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
              <div className='d-flex flex-column'>
                <div className='d-flex align-items-center mb-2'>
                  <a href='#' className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                    {dataAlumni?.fullname || data?.fullname || company?.companies_name || '-'}
                  </a>
                </div>

                <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                  <a
                    href='#'
                    className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                  >
                    {(dataAlumni || data)?.addresses?.map((item: any) => {
                      if (item.user_addresses_is_domicile == 1) {
                        return (
                          (item.city?.cities_name
                            ? item.city?.cities_name.toUpperCase() + ', '
                            : '') +
                          (item.province?.country?.countries_name
                            ? item.province?.country?.countries_name.toUpperCase()
                            : '')
                        )
                      } else {
                        return (
                          item.city?.cities_name || '', item.province?.country?.countries_name || ''
                        )
                      }
                    })}
                  </a>
                </div>

                <div className='d-flex align-items-center mb-2  d-grid gap-2'>
                  <a
                    href={`tel:+${data?.detail?.user_details_code_phone}${data?.detail?.user_details_phone}`}
                    className='btn btn-icon btn-primary btn-sm'
                  >
                    <i className='bi bi-telephone' />
                  </a>
                  <a
                    href={`mailto:${data?.email}`}
                    target='_blank'
                    className='btn btn-icon btn-primary btn-sm'
                    rel='noreferrer'
                  >
                    <i className='bi bi-envelope' />
                  </a>
                  <a
                    href={`https://wa.me/${data?.detail?.user_details_code_phone}${data?.detail?.user_details_phone}`}
                    target='_blank'
                    className='btn btn-icon btn-primary btn-sm'
                    rel='noreferrer'
                  >
                    <i className='bi bi-whatsapp' />
                  </a>
                </div>
              </div>

              <div className='d-flex my-4'>
                {/* {role == 'Alumni' && currentUri != allowedUrl[0] && currentUri != allowedUrl[1] && ( */}
                {(searchParams.get('alumni') || role == 'Alumni') && (
                  <Fragment>
                    {/* <a href='#' className='btn btn-sm btn-light me-2' id='kt_user_follow_button'>
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr012.svg'
                        className='svg-icon-3 d-none'
                      />

                      <span className='indicator-label'>Jadikan PDF</span>
                      <span className='indicator-progress'>
                        Please wait...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    </a> */}

                    {data.id_hash ? (
                      <a
                        onClick={() => handleDownloadResume()}
                        className='btn btn-sm btn-primary me-3'
                        data-bs-toggle='modal'
                        data-bs-target='#kt_modal_offer_a_deal'
                      >
                        Download Resume
                      </a>
                    ) : null}
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className='d-flex overflow-auto h-55px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            {(menus || finalMenu)?.map((item: any, key: any) => {
              let toPage = item.path
              const isJobCompanyByAlumni =
                currentUri.includes(allowedUrl[0]) || currentUri.includes(allowedUrl[1])
              toPage = isJobCompanyByAlumni
                ? `${toPage}?company=${searchParams.get('company')}`
                : toPage
              if (role == 'company' && item.title != 'Pekerjaan') {
                return (
                  <li className='nav-item' key={key}>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === item.path && 'active')
                      }
                      to={`${toPage}${
                        searchParams.get('alumni') ? `?alumni=${searchParams.get('alumni')}` : ''
                      }`}
                    >
                      {item.title}
                    </Link>
                  </li>
                )
              } else if (role != 'company') {
                return (
                  <li className='nav-item' key={key}>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === item.path && 'active')
                      }
                      to={`${toPage}${
                        searchParams.get('alumni') ? `?alumni=${searchParams.get('alumni')}` : ''
                      }`}
                    >
                      {item.title}
                    </Link>
                  </li>
                )
              } else {
                return null
              }
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}

export {ProfileHeader}
